import React from "react";
import logo from "../assets/images/logo1.png";
import { FaInstagram, FaFacebookF, FaTwitter } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-full font-nunito bg-white text-gray-800 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start text-center md:text-left">
          {/* Logo Section */}
          <div className="mb-6 md:mb-0 flex flex-col text-center items-center md:items-start">
            <img
              src={logo}
              alt="Company Logo"
              className="h-auto w-[200px] mb-4"
            />
            <h2 className="text-5xl font-dancing font-bold mb-8 text-center text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600">
              FlowHearts
            </h2>
          </div>

          {/* Services Section */}
          <div className="mb-6 md:mb-0">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition-all duration-500">
              Services
            </h2>
            <ul className="space-y-2">
              {[
                <Link to={'/period-tracker'}>Track Your Periods</Link>,
                <Link to={'/pregnancy-probability'}>Check Your Probability of Pregnancy</Link>,
                <Link to={'/wellness-tips'}>Tips For Health and Wellness</Link>,
                <Link to={'/average-day-calculator'}>Calculator Average Days</Link>,
                <Link to={'/safe-days-calculator'}>Know Your Safe Days</Link>,
                <Link to={'/pregnancy-tracker'}>Track Pregnancy</Link>,
                <Link to={'/nutrition-tips'}>Tips Of Nutrition</Link>,
              ].map((item, index) => (
                <li
                  key={index}
                  className="text-gray-600 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition-all duration-300 cursor-pointer"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="mb-6 md:mb-0 flex flex-col items-center md:items-start">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition-all duration-500">
              Social Track
            </h2>
            <div className="flex space-x-6">
              {/* Instagram */}
              <a
                href="#"
                className="group relative flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition duration-300"
              >
                <FaInstagram className="text-gray-700 group-hover:text-white text-lg transition" />
                <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 text-xs font-medium text-[#9ea3f5] transition-opacity duration-300 whitespace-nowrap">
                  Follow Us
                </span>
              </a>

              {/* Facebook */}
              <a
                href="#"
                className="group relative flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition duration-300"
              >
                <FaFacebookF className="text-gray-700 group-hover:text-white text-lg transition" />
                <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 text-xs font-medium text-[#9ea3f5] transition-opacity duration-300 whitespace-nowrap">
                  Like Us
                </span>
              </a>

              {/* Twitter */}
              <a
                href="#"
                className="group relative flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition duration-300"
              >
                <FaTwitter className="text-gray-700 group-hover:text-white text-lg transition" />
                <span className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 text-xs font-medium text-[#9ea3f5] transition-opacity duration-300 whitespace-nowrap">
                  Tweet Us
                </span>
              </a>
            </div>
          </div>

          {/* Company Section */}
          <div className="mb-6 md:mb-0">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition-all duration-500">
              Company
            </h2>
            <ul className="space-y-2">
              {[
                <Link to={'/'}>Home</Link>,
                <Link to={'/blog'}>Blog</Link>,
                <Link to={'/aboutus'}>About Us</Link>,
                <Link to={'/privacy-policy'}>Privacy Policy</Link>,
                <Link to={'/terms-of-service'}>Terms of Service</Link>,
              ].map((item, i) => (
                <li
                  key={i}
                  className="text-gray-600 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition-all duration-300 cursor-pointer"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section */}
          <div className="flex flex-col items-center md:items-start">
            <h2 className="text-xl font-semibold mb-4 text-gray-900 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition-all duration-500">
              Contact Us
            </h2>
            <ul className="space-y-2">
              {[
                "flowheartshelp@gmail.com",
              ].map((info, i) => (
                <li
                  key={i}
                  className="text-gray-600 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r from-[#bbbefe] via-[#9ea3f5] to-[#e8bffb] transition-all duration-300 cursor-pointer"
                >
                  <a href="mailto:flowheartshelp@gmail.com">{info}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-200 mt-8 pt-6 text-center text-gray-500 transition-all duration-500">
          <p>
            &copy; {new Date().getFullYear()} FlowHearts.com. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
